import { defineComponent as _defineComponent } from 'vue'
import Twitter from '@/assets/qrCode/twitter.png'
import Instagram from '@/assets/qrCode/instagram.png'
import Discord from '@/assets/qrCode/discord.png'
import Github from '@/assets/qrCode/github.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'qrCode',
  setup(__props) {

const qrCodeList = [
  {
    title: 'Discord',
    img: Discord,
    link: 'https://discord.gg/u6ymnbz4PR',
  },
  {
    title: 'Twitter',
    img: Twitter,
    link: 'https://twitter.com/KodaDot',
  },
  {
    title: 'Github',
    img: Github,
    link: 'https://github.com/kodadot/nft-gallery',
  },
  {
    title: 'Instagram',
    img: Instagram,
    link: 'https://instagram.com/kodadot.xyz',
  },
]

return { __sfc: true,qrCodeList }
}

})